module.exports = __webpack_public_path__ + "img/SER-A-3-II.706f9a84.png";